import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Percentage: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 15.167a2.917 2.917 0 100-5.834 2.917 2.917 0 000 5.834zm0-1.667a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM19.75 22.667a2.917 2.917 0 100-5.834 2.917 2.917 0 000 5.834zm0-1.667a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill={color}
      />
      <path
        d="M21.244 9.577L9.577 21.244l1.179 1.179 11.666-11.667-1.178-1.179z"
        fill={color}
      />
    </svg>
  );
};

export default Percentage;
